'use client';

import {
  AnchorHTMLAttributes,
  ForwardedRef,
  forwardRef,
  KeyboardEvent,
  useState,
} from 'react';
import classNames from 'classnames';
import './css/MenuLink.scss';

export const MenuLink = forwardRef(
  (
    props: AnchorHTMLAttributes<HTMLAnchorElement>,
    ref: ForwardedRef<HTMLAnchorElement>
  ) => {
    const { children, className, href, id, ...spreadProps } = props;

    const [isActive, setIsActive] = useState(false);

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === ' ') {
        setIsActive(true);
      }
    };

    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.key === ' ') {
        setIsActive(false);

        const link = e.target as HTMLAnchorElement;
        link.click();
      }
    };

    const classes = classNames({
      'ps-menu-item': true,
      'ps-menu-item-active': isActive,
      [`${className}`]: className,
    });

    return (
      <a
        className={classes}
        href={href}
        id={id}
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
        ref={ref}
        role="menuitem"
        tabIndex={-1}
        {...spreadProps}
      >
        {children}
      </a>
    );
  }
);
